<template>
  <div class="ma-4">
    <ClientNav/>
    <v-row dense>
      <v-col cols="12">
        <v-card>
          <v-card-title style="background-color: #2b3990">
            <span class="headline white--text">{{ titleForm }}</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-stepper v-model="e1">
                <v-stepper-header class="blue lighten-4">
                  <v-stepper-step :complete="e1 > 1" step="1" editable
                  >Medication Information
                  </v-stepper-step>

                  <v-divider></v-divider>

                  <v-stepper-step :complete="e1 > 2" step="2" editable
                  >MAR Scheduling
                  </v-stepper-step>

                  <v-divider></v-divider>

                  <v-stepper-step step="3" editable
                  >Authorizations
                  </v-stepper-step>
                </v-stepper-header>

                <validation-observer ref="observer">
                  <v-stepper-items>
                    <v-stepper-content :complete="e1 > 1" step="1">
                      <v-card class="mb-12" height="auto">
                        <v-layout row wrap class="ml-2 mr-2">
                          <v-flex xs12 sm3>
                            <validation-provider
                              v-slot="{ errors }"
                              name="Medication"
                              rules="required"
                            >
                              <v-select
                                id="medication-select"
                                return-object
                                v-model="newMedication"
                                label="Medication"
                                :items="inventories"
                                item-value="Name"
                                item-text="Medication"
                                class="ma-2"
                                :error-messages="errors"
                                @change="
                                  qtyChange();
                                  updateMed();
                                "
                              ></v-select>
                            </validation-provider>
                          </v-flex>
                          <v-flex xs12 sm3>
                            <validation-provider
                              v-slot="{ errors }"
                              name="Dosage Form"
                              rules="required"
                            >
                              <v-select
                                id="dosage-form-select"
                                label="Dosage Form"
                                class="ma-2"
                                v-model="newDosageForm"
                                :items="dosageForm"
                                :error-messages="errors"
                              >
                              </v-select>
                            </validation-provider>
                          </v-flex>
                          <v-flex xs12 sm3>
                            <validation-provider
                              v-slot="{ errors }"
                              name="Diagnosis"
                              rules="required"
                            >
                              <v-select
                                id="diagnosis-select"
                                label="Select Diagnosis"
                                :items="diagnoses"
                                item-text="Diagnosis"
                                item-value="Diagnosis"
                                v-model="newDiagnosis"
                                class="ma-2"
                                :error-messages="errors"
                              ></v-select>
                            </validation-provider>
                          </v-flex>
                          <v-flex xs12 sm3>
                            <validation-provider
                              v-slot="{ errors }"
                              name="Route of Administration"
                              rules="required"
                            >
                              <v-autocomplete
                                id="administration-route-select"
                                label="Route of Administration"
                                class="ma-2"
                                v-model="newAdministrationRoute"
                                :items="adminRoute"
                                :error-messages="errors"
                                @change="updateMarInstructions"
                              >
                              </v-autocomplete>
                            </validation-provider>
                          </v-flex>

                          <v-flex xs12 sm6>
                            <validation-provider
                              v-slot="{ errors }"
                              name="Strength"
                              rules=""
                            >
                              <v-subheader class="pl-1 subtitle-1">
                                Strength:
                                {{ strength }}%
                              </v-subheader>
                              <v-slider
                                v-model="strength"
                                :error-messages="errors"
                                min="0"
                                max="100"
                              >
                                <template v-slot:thumb-label="{ value }">
                                  {{ value }}%
                                </template>
                              </v-slider>
                            </validation-provider>
                          </v-flex>
                          <v-flex xs12 sm12>
                            <v-checkbox
                              :value="newVitals"
                              label="Vital Signs Required?"
                              @click="checkVitals()"
                              v-model="newVitals"
                            ></v-checkbox>
                          </v-flex>
                          <v-expand-transition>
                            <v-flex v-if="reqVitals" xs12>
                              <div>Vitals Required</div>
                              <v-select
                                multiple
                                :items="vitals"
                                item-text="Name"
                                item-value="Value"
                                v-model="newRequiredVitals"
                              ></v-select>
                            </v-flex>
                          </v-expand-transition>
                          <v-flex xs12 sm2>
                            <v-text-field
                              id="refills-allowed-input"
                              label="Refills Allowed"
                              v-model="newRefills"
                              class="ma-2"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 class="grey lighten-4 ma-1">
                            <validation-provider
                              v-slot="{ errors }"
                              name="Medication Classification"
                              rules=""
                            >
                              <div class="text-center font-weight-bold">
                                Medication Classification
                              </div>
                              <v-row align="center" justify="space-around">
                                <v-switch
                                  label="C2"
                                  class="ma-1"
                                  value="C2"
                                  v-model="newMedClass"
                                ></v-switch>
                                <v-switch
                                  label="C3 or C4"
                                  class="ma-1"
                                  value="C3"
                                  v-model="newMedClass"
                                ></v-switch>
                                <v-switch
                                  label="C5"
                                  class="ma-1"
                                  value="C5"
                                  v-model="newMedClass"
                                ></v-switch>
                                <v-switch
                                  label="Standard"
                                  class="ma-1"
                                  value="Standard"
                                  v-model="newMedClass"
                                ></v-switch>
                              </v-row>
                              <div v-if="errors.length > 0" class="error--text text-center mt-2">
                                {{ errors[0] }}
                              </div>
                            </validation-provider>
                          </v-flex>
                          <v-flex xs12 class="grey lighten-4 ma-1">
                            <validation-provider
                              v-slot="{ errors }"
                              name="Drug Categories"
                              rules=""
                            >
                              <div class="text-center font-weight-bold">
                                Drug Categories
                              </div>
                              <v-row align="center" justify="space-around">
                                <v-select
                                  multiple
                                  :items="drugCategories"
                                  v-model="newDrugCategory"
                                  label="Select Drug Categories"
                                  class="ma-6"
                                  :error-messages="errors"
                                ></v-select>
                              </v-row>
                            </validation-provider>
                          </v-flex>
                          <v-flex xs12 sm3>
                            <v-checkbox
                              label="Written Order"
                              hint="Was this order written?"
                              v-model="newWrittenOrder"
                              @change="onChangeWittenOrder"
                            >
                            </v-checkbox>
                          </v-flex>
                          <v-flex xs12 sm2 v-if="newWrittenOrder">
                            <v-row>
                              <v-radio-group v-model="writtenOrderType">
                                <v-radio
                                  label="Substitution Permitted"
                                  value="Substitution Permitted"
                                  class="ma-2"
                                >
                                </v-radio>
                                <v-radio
                                  label="Dispense as Written"
                                  value="Dispense as Written"
                                  class="ma-2"
                                >
                                </v-radio>
                              </v-radio-group>
                            </v-row>
                          </v-flex>
                          <v-flex xs12 class="grey lighten-4 ma-1">
                            <validation-provider
                              v-slot="{ errors }"
                              name="Assistance Needed"
                              rules=""
                            >
                              <div class="text-center font-weight-bold">
                                Assistance Needed
                              </div>
                              <v-row align="center" justify="space-around">
                                <v-switch
                                  label="Self-Administer"
                                  class="mb-1"
                                  value="Self-Administer"
                                  v-model="newAssistance"
                                ></v-switch>
                                <v-switch
                                  label="Self-Directed"
                                  class="mb-1"
                                  value="Self-Directed"
                                  v-model="newAssistance"
                                ></v-switch>
                                <v-switch
                                  label="Reminder to Take"
                                  class="mb-1"
                                  value="Reminder to Take"
                                  v-model="newAssistance"
                                ></v-switch>
                                <v-switch
                                  label="Opening of Container"
                                  class="mb-1"
                                  value="Opening of Container"
                                  v-model="newAssistance"
                                ></v-switch>
                                <v-switch
                                  label="Refill Reminder"
                                  class="mb-1"
                                  value="Refill Reminder"
                                  v-model="newAssistance"
                                ></v-switch>
                                <v-switch
                                  label="Designated Person"
                                  class="mb-1"
                                  value="Family/Designated Person"
                                  v-model="newAssistance"
                                ></v-switch>
                                <v-switch
                                  label="Significant/Total"
                                  class="mb-1"
                                  value="Significant/Total"
                                  v-model="newAssistance"
                                ></v-switch>
                              </v-row>
                              <div v-if="errors.length > 0" class="error--text text-center mt-2">
                                {{ errors[0] }}
                              </div>
                            </validation-provider>
                          </v-flex>
                          <v-flex xs12>
                            <v-textarea
                              label="Physician's Instructions"
                              outlined
                              v-model="newInstructions"
                            >
                            </v-textarea>
                          </v-flex>
                        </v-layout>
                      </v-card>

                      <v-btn
                        color="#2b3990"
                        class="white--text"
                        @click="validateStep1"
                      >
                        Continue
                        <v-icon right>arrow_forward</v-icon>
                      </v-btn>
                    </v-stepper-content>

                    <v-stepper-content step="2">
                      <v-card class="mb-12" height="auto">
                        <v-row wrap class="ml-2 mr-2">
                          <v-col cols="12" md="3" sm="12">
                            <validation-provider
                              v-slot="{ errors }"
                              name="Quantity"
                              rules=""
                            >
                              <v-text-field
                                id="quantity-input"
                                label="Quantity"
                                v-model.number="newQuantity"
                                class="ma-2"
                                type="number"
                                :hint="`Remaining quantity: ${qty}`"
                                :error-messages="errors"
                                @change="updateMarInstructions"
                              />
                            </validation-provider>
                          </v-col>
                          <v-col cols="12" md="3" sm="12">
                            <validation-provider
                              v-slot="{ errors }"
                              name="Units"
                              rules="required"
                            >
                              <v-select
                                id="units-select"
                                v-model="newUnit"
                                :items="unitType"
                                item-text="Name"
                                item-value="_id"
                                label="Units"
                                class="ma-2"
                                :error-messages="errors"
                                @change="updateMarInstructions"
                              ></v-select>
                            </validation-provider>
                          </v-col>

                          <v-col cols="12" md="3" sm="12">
                            <validation-provider
                              v-slot="{ errors }"
                              name="Dosage"
                              rules="required"
                            >
                              <v-text-field
                                id="strength-input"
                                label="Strength"
                                class="ma-2"
                                v-model="newDosage"
                                :error-messages="errors"
                                @change="updateMarInstructions"
                              >
                              </v-text-field>
                            </validation-provider>
                          </v-col>
                          <v-flex xs12>
                            <validation-provider
                              v-slot="{ errors }"
                              name="Scheduling Options"
                              rules=""
                            >
                              <div class="text-center">Scheduling Options</div>
                              <v-row align="center" justify="space-around">
                                <v-switch
                                  label="Daily or PRN"
                                  class="ma-1"
                                  value="Daily or PRN"
                                  v-model="newScheduleOptions"
                                  @click="checkOptions(newScheduleOptions)"
                                ></v-switch>
                                <v-switch
                                  label="Every (Interval) Days"
                                  class="ma-1"
                                  value="Every (Interval) Days"
                                  v-model="newScheduleOptions"
                                  @click="checkOptions(newScheduleOptions)"
                                ></v-switch>
                                <v-switch
                                  label="Days of the Week"
                                  class="ma-1"
                                  value="Specific Days of the Week"
                                  v-model="newScheduleOptions"
                                  @click="checkOptions(newScheduleOptions)"
                                ></v-switch>
                                <v-switch
                                  label="Days of the Month"
                                  class="ma-1"
                                  value="Specific Days of the Month"
                                  v-model="newScheduleOptions"
                                  @click="checkOptions(newScheduleOptions)"
                                ></v-switch>
                              </v-row>
                              <div v-if="errors.length > 0" class="error--text text-center mt-2">
                                {{ errors[0] }}
                              </div>
                            </validation-provider>
                          </v-flex>
                          <v-flex xs12>
                            <!-- if switch is interval days -->
                            <div v-if="times" class="grey lighten-3 pa-4 mb-4">
                              <h1
                                class="font-weight-light text-center"
                                v-if="dailyPRN"
                              >
                                Daily or PRN
                              </h1>
                              <h1
                                class="font-weight-light text-center"
                                v-if="intervalDays"
                              >
                                Interval Days
                              </h1>
                              <h1
                                class="font-weight-light text-center"
                                v-if="specificDays"
                              >
                                Specific Days of the Week
                              </h1>
                              <h1
                                class="font-weight-light text-center"
                                v-if="specificMonth"
                              >
                                Specific Days of the Month
                              </h1>
                              <v-divider class="ma-8"></v-divider>
                              <v-layout row wrap>
                                <v-flex xs12 sm4 class="ma-3">
                                  <validation-provider
                                    v-slot="{ errors }"
                                    name="Start Date"
                                    rules=""
                                  >
                                    <v-datetime-picker
                                      label="Start Date"
                                      v-model="newStartDate"
                                      :error-messages="errors"
                                      @input="updateMarInstructions"
                                    >
                                    </v-datetime-picker>
                                  </validation-provider>
                                </v-flex>
                                <v-flex xs12 sm3 class="ma-3">
                                  <v-switch
                                    label="Indefinite medication"
                                    :input-value="isIndefinite"
                                    v-model="isIndefinite"
                                    @change="updateMarInstructions"
                                  ></v-switch>
                                </v-flex>
                                <v-flex xs12 sm4 class="ma-3">
                                  <validation-provider
                                    v-slot="{ errors }"
                                    name="End Date"
                                    rules=""
                                  >
                                    <v-datetime-picker
                                      label="End Date"
                                      v-model="newEndDate"
                                      :error-messages="errors"
                                      :disabled="isIndefinite"
                                      @input="updateMarInstructions"
                                    >
                                    </v-datetime-picker>
                                  </validation-provider>
                                </v-flex>
                                <v-flex xs12 sm6 class="ma-2">
                                  <validation-provider
                                    v-slot="{ errors }"
                                    name="Interval Days"
                                    rules=""
                                  >
                                    <v-text-field
                                      v-model="newIntervalDays"
                                      label="How many interval days?"
                                      :error-messages="errors"
                                      v-if="intervalDays"
                                    ></v-text-field>
                                  </validation-provider>
                                  <validation-provider
                                    v-slot="{ errors }"
                                    name="Days of Week"
                                    rules=""
                                  >
                                    <v-select
                                      data-cy="days-of-the-week"
                                      multiple
                                      v-model="newDaysOfWeek"
                                      :items="daysOfWeek"
                                      label="What days of the week?"
                                      :error-messages="errors"
                                      v-if="specificDays"
                                    ></v-select>
                                  </validation-provider>
                                  <validation-provider
                                    v-slot="{ errors }"
                                    name="Days of Month"
                                    rules=""
                                  >
                                    <v-select
                                      multiple
                                      v-model="newDaysOfMonth"
                                      :items="daysOfMonth"
                                      label="What days of the month?"
                                      :error-messages="errors"
                                      v-if="specificMonth"
                                    ></v-select>
                                  </validation-provider>
                                </v-flex>
                              </v-layout>
                            </div>
                          </v-flex>

                          <v-flex xs12>
                            <validation-provider
                              v-slot="{ errors }"
                              name="Schedule"
                              rules="required"
                            >
                              <v-select
                                :items="adminTime"
                                label="Scheduled Time(s)"
                                v-model="newAdminTime"
                                :error-messages="
                                  errors != ''
                                    ? 'Please select schedule'
                                    : errors
                                "
                                multiple
                                @change="updateMarInstructions"
                              />
                            </validation-provider>
                          </v-flex>
                          <v-flex xs12 v-if="newAdminTime && newAdminTime.includes('PRN')">
                            <v-select
                              v-model="prnInterval"
                              label="PRN Interval"
                              :items="prnIntervalOptions"
                              @change="updateMarInstructions"
                            ></v-select>
                          </v-flex>
                          <v-flex xs12 v-if="newAdminTime && newAdminTime.includes('PRN')">
                            <validation-provider
                              v-slot="{ errors }"
                              name="PRN Diagnosis"
                              rules="required"
                            >
                              <v-text-field
                                label="Diagnosis"
                                v-model="prnDiagnosis"
                                :run="
                                  !prnDiagnosis
                                    ? (prnDiagnosis = newDiagnosis)
                                    : true
                                "
                                :error-messages="errors"
                                @change="updateMarInstructions"
                              ></v-text-field>
                            </validation-provider>
                          </v-flex>
                          <v-flex xs12 v-if="newAdminTime && newAdminTime.includes('PRN')">
                            <v-select
                              label="PRN Follow-Up"
                              v-model="prn"
                              :items="followUp"
                              @change="updateMarInstructions"
                            ></v-select>
                          </v-flex>
                          <v-flex xs12>
                            <v-textarea
                              outlined
                              label="MAR Instructions"
                              class="ma-2"
                              v-model="newMARInstructions"
                            >
                            </v-textarea>
                          </v-flex>
                          <v-flex xs12 sm3>
                            <v-text-field
                              label="Additional Timing"
                              class="ma-2"
                              v-model="newAdditionalTiming"
                            >
                            </v-text-field>
                          </v-flex>
                        </v-row>
                      </v-card>

                      <v-btn
                        class="ma-2 white--text"
                        color="#2b3990"
                        @click="e1 = 1"
                      >
                        <v-icon left>arrow_back</v-icon>
                        Back
                      </v-btn>
                      <v-btn
                        color="#2b3990"
                        class="white--text"
                        @click="validateStep2"
                        data-cy="step-2-continue"
                      >
                        Continue
                        <v-icon right> arrow_forward</v-icon>
                      </v-btn>
                    </v-stepper-content>

                    <v-stepper-content step="3">
                      <v-card class="mb-12 mt-5" height="auto">
                        <v-layout row wrap class="ml-2 mr-2">
                          <v-flex xs12 sm4>
                            <validation-provider
                              v-slot="{ errors }"
                              name="Prescribed By"
                              rules="required"
                            >
                              <v-autocomplete
                                v-model="newPrescribedBy"
                                :items="providers"
                                data-cy="prescribed-by-select"
                                item-text="Provider.Name"
                                item-value="Provider._id"
                                label="Prescribed By"
                                class="pa-1"
                                clearable
                                :error-messages="errors"
                                @change="onSelectProvider"
                              ></v-autocomplete>
                            </validation-provider>
                          </v-flex>
                          <v-flex xs12 sm4>
                            <v-text-field
                              label="RX Number"
                              class="pa-1"
                              v-model="newRXNumber"
                            ></v-text-field>
                          </v-flex>
                          <v-flex xs12 sm4>
                            <v-menu
                              content-class="expiration-menu-content"
                              ref="menu"
                              v-model="menu"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              transition="scale-transition"
                              offset-y
                              min-width="290px"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  data-cy="expiration-input"
                                  class="pa-1"
                                  v-model="newExpirationDate"
                                  label="Expiration Date"
                                  readonly
                                  v-bind="attrs"
                                  v-on="on"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                v-model="newExpirationDate"
                                no-title
                                scrollable
                              >
                                <v-spacer></v-spacer>
                                <v-btn
                                  text
                                  color="primary"
                                  @click="menu = false"
                                >
                                  Cancel
                                </v-btn>
                                <v-btn
                                  text
                                  color="primary"
                                  @click="$refs.menu.save(newExpirationDate)"
                                >
                                  OK
                                </v-btn>
                              </v-date-picker>
                            </v-menu>
                          </v-flex>
                          <v-flex xs6>
                            <v-row>
                              <v-checkbox
                                v-model="isDataEntered"
                                label="Data Entered By"
                                hint="By clicking, I certify this information is complete and correct"
                                class="ma-4"
                                @change="addSignature"
                              >
                              </v-checkbox>
                              <v-checkbox
                                label="Nursing/Administrator Review"
                                hint="By clicking, I certify this information is complete and correct"
                                class="ma-4"
                                v-model="newNursingReview"
                              >
                              </v-checkbox>
                            </v-row>
                          </v-flex>
                          <v-flex xs12>
                            <v-expansion-panel>
                              <v-text-field
                                v-model="newEnteredBy"
                                readonly
                                v-if="isDataEntered"
                              ></v-text-field>
                            </v-expansion-panel>
                          </v-flex>
                        </v-layout>
                      </v-card>

                      <v-btn
                        class="ma-2 white--text"
                        color="#2b3990"
                        @click="e1 = 2"
                      >
                        <v-icon left>arrow_back</v-icon>
                        Back
                      </v-btn>
                    </v-stepper-content>
                  </v-stepper-items>
                </validation-observer>
              </v-stepper>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-switch
              v-if="!userRole"
              v-model="isActive"
              :label="!isActive ? 'Discontinued' : 'Active'"
              @change="onSwitchStatus(isActive)"
            ></v-switch>
            <v-spacer></v-spacer>

            <div>
              <v-btn
                data-cy="med-save"
                class="white--text"
                color="#259647"
                @click="validateStep3()"
                v-if="(createMedication || copyMedication) && !userRole"
              >Save
              </v-btn>
              <v-btn
                fab
                small
                @click="showPrintModal()"
                class="mr-8 mb-2 white--text"
                color="#2b6993"
                elevation="4"
                v-if="!createMedication && !copyMedication && isActive "
              >
                <v-icon>print</v-icon>
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                @click="validateStep3()"
                v-if="!createMedication && !copyMedication && isActive && !userRole"
              >Update
              </v-btn>
            </div>

            <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <Foot/>
  </div>
</template>

<script>
/* eslint-disable */
import axios from "axios";
import ClientNav from "../../../components/ClientNav";
import Foot from "../../../components/Footer";

const url = require("../../../client_config/config").url;
import moment from "moment";
import {ValidationObserver, ValidationProvider} from "vee-validate";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import reports from "@/mixins/reports";
import {mapActions} from "vuex";
import {Notyf} from "notyf";
import "notyf/notyf.min.css";

import DateTimeUtil from "../../../../utils/date-time.util";

const notyf = new Notyf({
  duration: 3000,
  position: {
    y: "top",
  },
  dismissible: true,
  types: [
    {
      type: "info",
      background: "#1E90FF",
      duration: 2000,
      dismissible: true,
    },
  ],
});

// constant
import schedule from "../../../constants/ScheduleTime";
import Swal from "sweetalert2";
import PrintUtil from "../../../../utils/print-util";

let MORNING = schedule.MORNING();
let AFTERNOON = schedule.AFTERNOON();
let EVENING = schedule.EVENING();
let EVENING2 = schedule.EVENING2();

export default {
  components: {
    ClientNav,
    Foot,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [reports],
  data: function () {
    return {
      headers: [
        {
          text: "Medication Name",
          align: "start",
          sortable: true,
          value: "Medication",
        },
        {text: "Med Class", value: "MedClass"},
        {text: "Prescribed By", value: "PrescribedBy.Name"},
        {text: "Physician Instructions", value: "Instructions", width: "20%"},
        {text: "Admin Time", value: "AdminTime"},
        {text: "RX", value: "RXNumber"},
        // { text: "Order Fill/Refill", value: "Refill" },
        {text: "Actions", value: "actions", sortable: false},
      ],
      tab: null,
      strength: 0,
      items: ["Medications", "Discontinued Medications"],
      isActive: false,
      isCopy: false,
      page: "main",
      e1: 1,
      dialog: false,
      editMedications: false,
      newMedications: false,
      msg: false,
      text: "",
      search: "",
      medications: [],
      discontinuedMedications: [],
      users: [],
      tempData: [],
      units: [],
      signed: false,
      staff: localStorage.getItem("Name"),
      token: localStorage.getItem('token'),
      providers: [],
      times: false,
      vitals: [
        {Name: "Blood Pressure", Value: "BloodPressure"},
        {Name: "Heart Rate", Value: "HeartRate"},
        {Name: "Temperature", Value: "Temperature"},
        {Name: "Glucose/Blood Sugar", Value: "BloodSugar"},
        {Name: "Respiratory Rate", Value: "RespiratoryRate"},
        {Name: "Weight", Value: "Weight"},
        {Name: "02 Stats", Value: "Stats"},
      ],
      reqVitals: false,
      userID: localStorage.getItem("userID"),
      clientID: this.$route.params.clientID,
      prn: "",
      followUp: [
        "15 Minutes",
        "30 Minutes",
        "45 Minutes",
        "1 Hour",
        "2 Hours",
        "3 Hours",
      ],
      // adminTime: [
      //   "12:00am",
      //   "1:00am",
      //   "2:00am",
      //   "3:00am",
      //   "4:00am",
      //   "5:00am",
      //   "6:00am",
      //   "7:00am",
      //   "8:00am",
      //   "9:00am",
      //   "10:00am",
      //   "11:00am",
      //   "12:00pm",
      //   "1:00pm",
      //   "2:00pm",
      //   "3:00pm",
      //   "4:00pm",
      //   "5:00pm",
      //   "6:00pm",
      //   "7:00pm",
      //   "8:00pm",
      //   "9:00pm",
      //   "10:00pm",
      //   "11:00pm",
      //   "PRN",
      // ],
      adminTime: [],
      drugCategories: [
        "Analgesics",
        "Antianxiety",
        "Antibiotics",
        "Anticoagulant",
        "Anticonvulsants",
        "Antidepressant",
        "Antidiuretic",
        "Antipsychotic",
        "Anxiolytics",
        "Cardiac",
        "Diabetic",
        "Diuretic",
        "Hypnotic",
        "Laxative",
        "Mood Stabilizer",
        "Ophthalmic Preparations",
        "Pain",
        "Psychotropic",
        "Sedative",
        "Stimulant",
        "Supplement",
      ],
      titleForm: "New Medication",
      dosageForm: [
        "Capsule",
        "Chewable",
        "Cream",
        "Drops",
        "Gel",
        "Inhaler",
        "Injection",
        "Liquid",
        "Lotion",
        "Nebulizer",
        "Ointment",
        "Patch",
        "Powder",
        "Solution",
        "Suspension",
        "Suppository",
        "Spray",
        "Tablet",
        "Tablet, chewable",

        "Unknown",
      ],
      adminRoute: [
        "01 Oral (PO)",
        "01 Oral/Sub-lingal (SL)",
        "01 Intramuscular (IM)",
        "02 Subcutaneous",
        "03 NG/gastric (NG)",
        "03 Enteral tube (ET)",
        "04 Topical (T)",
        "05 Rectal/vaginal (R)",
        "06 Inhalent (I)",
        "07 Intravenous (IV)",
        "08 Other",
        "09 Unknown",
      ],
      unitType: [
        "Aampule",
        "Applicatorful",
        "Bottle",
        "Can",
        "Capful",
        "Capsule",
        "CC",
        "Drop",
        "Enema",
        "Gallon",
        "Grams",
        "Inch",
        "Liter",
        "Liters/Minute",
        "Liquid",
        "Lozenge",
        "Milligram",
        "Mililiter",
        "Mililiters/Hr",
        "Minibag",
        "N/A",
        "Ounce",
        "Packet",
        "Puff",
        "Scoop",
        "Serving",
        "Sliding Scale",
        "Sparingly",
        "Spray",
        "Suppository",
        "Tablespoon",
        "Tablet",
        "Teaspoon",
        "Thin Layer",
        "Unit Dose",
        "Units",
        "Vial",
      ],
      medicationID: this.$route.params.id,
      newMedication: "",
      newDosageForm: "",
      newDiagnosis: "",
      newAdministrationRoute: "",
      newVitals: false,
      newRequiredVitals: [],
      newRefills: "",
      newMedClass: [],
      newDrugCategory: [],
      newWrittenOrder: false,
      writtenOrderType: null,
      newAssistance: [],
      newInstructions: "",
      newQuantity: "",
      newAdministerAmount: "",
      newUnit: "",
      newDosage: "",
      newScheduleOptions: [],
      newStartDate: new Date(),
      newEndDate: new Date(),
      newIntervalDays: "",
      newDaysOfWeek: [],
      newDaysOfMonth: [],
      dailyPRN: false,
      intervalDays: false,
      specificDays: false,
      specificMonth: false,
      newMARInstructions: "",
      newAdditionalTiming: "",
      inventories: [],
      qty: [],
      itemQty: 0,
      InventoryID: "",
      newItem: "",
      // newMedGroup: "",
      newPrescribedBy: "",
      newRXNumber: "",
      newEnteredBy: "",
      newNursingReview: "",
      newAdminTime: [],
      daysOfWeek: [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday",
      ],
      daysOfMonth: [
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23",
        "24",
        "25",
        "26",
        "27",
        "28",
        "29",
        "30",
        "31",
      ],
      diagnoses: [],
      requiredField: [(v) => !!v || "This is required"],
      editedIndex: -1,
      editedItem: {
        medication: "",
        dosageForm: "",
        diagnosis: "",
        administrationRoute: "",
        vitals: "",
        requiredVitals: [],
        refills: "",
        medClass: "",
        drugCategory: "",
        writtenOrder: "",
        assistance: "",
        instructions: "",
        quantity: "",
        unit: "",
        dosage: "",
        scheduleOptions: "",
        startDate: "",
        endDate: "",
        interval: "",
        daysOfWeek: [],
        daysOfMonth: [],
        mARInstructions: "",
        additionalTiming: "",
        // medGroup: "",
        prescribedBy: "",
        rxNumber: "",
        enteredBy: "",
        nursingReview: "",
      },
      defaultItem: {
        medication: "",
        dosageForm: "",
        diagnosis: "",
        administrationRoute: "",
        vitals: "",
        requiredVitals: [],
        refills: "",
        medClass: "",
        drugCategory: "",
        writtenOrder: "",
        assistance: "",
        instructions: "",
        quantity: "",
        unit: "",
        dosage: "",
        scheduleOptions: "",
        startDate: "",
        endDate: "",
        interval: "",
        daysOfWeek: [],
        daysOfMonth: [],
        mARInstructions: "",
        additionalTiming: "",
        // medGroup: "",
        prescribedBy: "",
        rxNumber: "",
        enteredBy: "",
        nursingReview: "",
      },
      isDataEntered: false,
      isLoading: true,
      totalDosage: 0,
      prnDiagnosis: "",
      formattedDosage: "",
      isIndefinite: true,
      providerId: null,
      actions: ["Print", "Download"],
      actionInProgress: false,
      medication: {},
      createMedication: false,
      copyMedication: false,
      prnIntervalOptions: [
        "once daily",
        "twice daily",
        "three times daily",
        "four times Daily",
        "every 4 hours",
        "every 6 hours",
        "every 8 hours",
      ],
      prnInterval: "",
      medicationStatus: null,
      newExpirationDate: "",
      menu: false,
    };
  },
  computed: {
    formTitle() {
      return this.editedIndex !== 1 ? "New Item" : "Edit Item";
    },
    client() {
      return {
        name: this.$store.state.clients?.client?.Name,
      };
    },

    itemQuantity() {
      return this.qty;
    },

    numberMask() {
      return createNumberMask({
        prefix: "",
        allowDecimal: true,
        includeThousandsSeparator: false,
      });
    },
    userRole() {
      return localStorage.getItem("userRole") === 'Auditor'
    }
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },
  created() {
    this.createMedication = this.$route.query.createMedication === "true";
    this.copyMedication = this.$route.query.copyMedication === "true";

    this.clientID = this.$route.params.clientID;
    this.getMedications();
    this.getUnits();
    this.getProviders();
    this.getInventories();
    this.getDiagnoses(this.clientID);
    this.adminTime = this.adminTime.concat(
      EVENING2,
      MORNING,
      AFTERNOON,
      EVENING,
      "PRN"
    );
  },

  mounted() {
    if (!this.createMedication) {
      this.getMedication();
    }

    window.addEventListener('keydown', async (event) => {
      const downloadUrl = await this.generateDownloadUrl();
      PrintUtil.handleKeydown(event, downloadUrl, this.medicationID, this.token, 'MedicationForm');
    });
  },

  beforeDestroy() {
    window.removeEventListener('keydown', (event) => {
      PrintUtil.handleKeydown(event, this.downloadUrl, this.medicationID, this.token, 'MedicationForm');
    });
  },

  methods: {
    ...mapActions({
      getClientProviders: "clientProviders/getItem",
      generateDynamicReport: "reports/generateDynamicReport",
    }),

    initialize() {
      this.Medications = [];
    },

    viewMedication(item, copy) {
      this.titleForm = copy ? "New Medication" : "Viewing " + item.Medication;
      this.newMedication = item.Medication;
      this.newDosageForm = item.DosageForm;
      this.newDiagnosis = item.Diagnosis;
      this.newAdministrationRoute = item.AdministrationRoute;
      this.newVitals = item.Vitals;
      this.newRequiredVitals = item.VitalsRequired;
      this.newRefills = item.Refills;
      this.newMedClass = item.MedClass;
      this.newDrugCategory = item.DrugCategory;
      this.newWrittenOrder = item.WrittenOrder ? item.WrittenOrder : false;
      this.writtenOrderType = item.WrittenOrderType;
      this.newAssistance = item.Assistance;
      this.newInstructions = item.Instructions;
      this.newQuantity = item.Quantity;
      this.newAdministerAmount = item.AdministerAmount;
      this.newUnit = item.Unit;
      this.newDosage = item.Dosage;
      this.strength = item.Strength;
      this.newScheduleOptions = item.ScheduleOptions;
      this.prnInterval = item.PrnInterval;
      this.newStartDate = moment(new Date(item.StartDate)).format(
        "YYYY-MM-DD HH:mm"
      );
      this.newEndDate = moment(new Date(item.EndDate)).format(
        "YYYY-MM-DD HH:mm"
      );
      this.newIntervalDays = item.IntervalDays;
      this.newDaysOfWeek = item.DaysOfWeek;
      this.newDaysOfMonth = item.DaysOfMonth;
      this.newMARInstructions = item.MARInstructions;
      this.newAdditionalTiming = item.AdditionalTiming;
      // this.newMedGroup= item.MedGroup;
      this.newPrescribedBy = this.providers.find(
        (provider) => provider.Provider._id === item?.PrescribedBy?._id
      );
      this.providerId = this.newPrescribedBy?.Provider?._id || null;
      this.newRXNumber = item.RXNumber;
      this.newNursingReview = item.NursingReview;
      this.newAdminTime = item.AdminTime;
      this.medicationID = item._id;
      this.newVitals = item.VitalsRequired.length !== 0;

      if (this.newVitals) {
        this.checkVitals();
      }

      this.checkOptions(item.ScheduleOptions);
      this.isActive = item.IsActive;
      this.medicationStatus = item.IsActive
      this.prn = item.PRN;
      this.prnDiagnosis = item.PRNDiagnosis;

      this.newExpirationDate = moment(new Date(item.ExpirationDate)).format("YYYY-MM-DD");
      this.newExpirationDate = this.newExpirationDate === "Invalid date" ? "" : this.newExpirationDate;

      // this.qty = [...Array(parseInt(item.MedInventory.Quantity)).keys()].map((x) => x + 1);
      this.qty = item.MedInventory?.Quantity;
      this.InventoryID = item.MedInventory?._id;
      this.isIndefinite =
        item.IsIndefinite === undefined ? true : item.IsIndefinite;

      if (item.EnteredBy !== "") {
        this.newEnteredBy = item.EnteredBy;
        this.isDataEntered = true;
        if(this.newEnteredBy.includes("Z")){
          this.newEnteredBy = this.formatSignature(this.newEnteredBy);
        }
      }

    },

    async validateStep1() {
      try {
        console.log('Validating step 1...');
        console.log('Form data:', {
          newMedication: this.newMedication,
          newDosageForm: this.newDosageForm,
          newDiagnosis: this.newDiagnosis,
          newAdministrationRoute: this.newAdministrationRoute,
          newMedClass: this.newMedClass,
          newDrugCategory: this.newDrugCategory,
          newAssistance: this.newAssistance,
          newScheduleOptions: this.newScheduleOptions,
          strength: this.strength
        });

        // Validate only required fields for step 1
        const validationErrors = [];

        // Check essential required fields only
        const medicationError = this.validateField(this.newMedication, 'select Medication');
        if (medicationError) validationErrors.push(medicationError);

        const dosageFormError = this.validateField(this.newDosageForm, 'select Dosage Form');
        if (dosageFormError) validationErrors.push(dosageFormError);

        const diagnosisError = this.validateField(this.newDiagnosis, 'select Diagnosis');
        if (diagnosisError) validationErrors.push(diagnosisError);

        const routeError = this.validateField(this.newAdministrationRoute, 'select Route of Administration');
        if (routeError) validationErrors.push(routeError);

        // If there are validation errors, show them and return
        if (!this.showValidationErrors(validationErrors)) {
          return;
        }

        // If all validations pass, proceed to next step
        this.e1 = 2;

        // Try the full validation but don't block if it fails
        try {
          const isValid = await this.$refs.observer.validate();
          console.log('Step 1 validation result:', isValid);
        } catch (validationError) {
          console.error('Validation error (non-blocking):', validationError);
        }

      } catch (error) {
        console.error('Step 1 validation error:', error);
        notyf.error("Please check all required fields in step 1 and try again.");
      }
    },

    async validateStep2() {
      try {
        console.log('Validating step 2...');
        console.log('Step 2 form data:', {
          newQuantity: this.newQuantity,
          newQuantityType: typeof this.newQuantity,
          newUnit: this.newUnit,
          newDosage: this.newDosage,
          newStartDate: this.newStartDate,
          newEndDate: this.newEndDate,
          newAdminTime: this.newAdminTime,
          times: this.times,
          isIndefinite: this.isIndefinite
        });

        // Validate only required fields for step 2
        const validationErrors = [];

        // Check essential required fields only
        const quantityError = this.validateField(this.newQuantity, 'enter a valid quantity (greater than 0)', true,
          (value) => value <= 0 ? 'Please enter a valid quantity (greater than 0).' : null);
        if (quantityError) validationErrors.push(quantityError);

        const unitError = this.validateField(this.newUnit, 'select Units');
        if (unitError) validationErrors.push(unitError);

        const dosageError = this.validateField(this.newDosage, 'enter Dosage');
        if (dosageError) validationErrors.push(dosageError);

        const adminTimeError = this.validateField(this.newAdminTime, 'select Scheduled Time(s)');
        if (adminTimeError) validationErrors.push(adminTimeError);

        // Check if scheduling section is visible and has required fields
        if (this.times) {
          const startDateError = this.validateField(this.newStartDate, 'select a Start Date');
          if (startDateError) validationErrors.push(startDateError);

          // Check end date only if not indefinite
          if (!this.isIndefinite) {
            const endDateError = this.validateField(this.newEndDate, 'select an End Date or mark as indefinite');
            if (endDateError) validationErrors.push(endDateError);
          }

          // Optional scheduling fields - no validation required
          // if (this.intervalDays) {
          //   const intervalError = this.validateField(this.newIntervalDays, 'enter a valid number of interval days', true,
          //     (value) => value <= 0 ? 'Please enter a valid number of interval days.' : null);
          //   if (intervalError) validationErrors.push(intervalError);
          // }
        }

        // If there are validation errors, show them and return
        if (!this.showValidationErrors(validationErrors)) {
          return;
        }

        // If all validations pass, proceed to next step
        this.e1 = 3;

        // Try the full validation but don't block if it fails
        try {
          const isValid = await this.$refs.observer.validate();
          console.log('Step 2 validation result:', isValid);
        } catch (validationError) {
          console.error('Validation error (non-blocking):', validationError);
        }

      } catch (error) {
        console.error('Step 2 validation error:', error);
        notyf.error("Please check all required fields in step 2 and try again.");
      }
    },

    // Utility function for field validation
    validateField(field, fieldName, isRequired = true, customValidation = null) {
      if (isRequired && (!field || (typeof field === 'string' && field.trim() === '') ||
        (typeof field === 'number' && field <= 0) || (Array.isArray(field) && field.length === 0))) {
        return `Please ${fieldName.toLowerCase()}.`;
      }

      if (customValidation) {
        return customValidation(field);
      }

      return null;
    },

    // Utility function to show validation errors
    showValidationErrors(errors) {
      if (errors.length > 0) {
        notyf.error(errors.join(" "));
        return false;
      }
      return true;
    },

    async validateStep3() {
      try {
        console.log('Validating step 3...');
        console.log('Step 3 form data:', {
          newPrescribedBy: this.newPrescribedBy,
          newRXNumber: this.newRXNumber,
          newExpirationDate: this.newExpirationDate,
          isDataEntered: this.isDataEntered,
          newNursingReview: this.newNursingReview
        });

        // Validate only required fields for step 3
        const validationErrors = [];

        // Check only required fields
        const prescribedByError = this.validateField(this.newPrescribedBy, 'select Prescribed By');
        if (prescribedByError) validationErrors.push(prescribedByError);

        // Note: Data Entered By and Nursing Review are certification checkboxes
        // They are optional but recommended for compliance purposes
        // Users can proceed without checking them, but it's recommended for audit trails

        // If there are validation errors, show them and return
        if (!this.showValidationErrors(validationErrors)) {
          return;
        }

        // If all validations pass, proceed with save
        this.onAddMedication();

      } catch (error) {
        console.error('Step 3 validation error:', error);
        notyf.error("Please check all required fields in step 3 and try again.");
      }
    },

    async onAddMedication() {
      try {
        console.log('Validating for save...');
        console.log('Save form data:', {
          newMedication: this.newMedication,
          newDosageForm: this.newDosageForm,
          newDiagnosis: this.newDiagnosis,
          newAdministrationRoute: this.newAdministrationRoute,
          newQuantity: this.newQuantity,
          newUnit: this.newUnit,
          newDosage: this.newDosage,
          newPrescribedBy: this.newPrescribedBy
        });

        // Check essential fields for save
        const essentialFields = [
          this.newMedication,
          this.newDosageForm,
          this.newDiagnosis,
          this.newAdministrationRoute,
          this.newQuantity,
          this.newUnit,
          this.newDosage,
          this.newPrescribedBy
        ];

        const hasEssentialFields = essentialFields.every(field => {
          if (!field) return false;
          if (typeof field === 'string') return field.trim() !== '';
          if (typeof field === 'number') return field > 0;
          if (Array.isArray(field)) return field.length > 0;
          return true;
        });

        if (!hasEssentialFields) {
          notyf.error("Please fill in all essential fields: Medication, Dosage Form, Diagnosis, Route of Administration, Quantity, Units, Dosage, and Prescribed By.");
          return;
        }

        // Check if scheduling section is visible and has required fields
        if (this.times) {
          if (!this.newStartDate) {
            notyf.error("Please select a Start Date.");
            return;
          }

          // Check end date only if not indefinite
          if (!this.isIndefinite && !this.newEndDate) {
            notyf.error("Please select an End Date or mark as indefinite.");
            return;
          }

          // Check conditional fields based on scheduling options
          // Optional scheduling fields - no validation required
          // if (this.intervalDays && !this.newIntervalDays) {
          //   notyf.error("Please enter the number of interval days.");
          //   return;
          // }

          // if (this.specificDays && (!this.newDaysOfWeek || this.newDaysOfWeek.length === 0)) {
          //   notyf.error("Please select days of the week.");
          //   return;
          // }

          // Days of Month is optional - no validation required
          // if (this.specificMonth && (!this.newDaysOfMonth || this.newDaysOfMonth.length === 0)) {
          //   notyf.error("Please select days of the month.");
          //   return;
          // }
        }

        // If all validations pass, proceed with save
        if (this.createMedication) {
          this.addMedication();
        } else if (this.copyMedication) {
          // Assigning InventoryID if using Medication Copy function
          let inventory = this.inventories.find(
            (item) => item.Medication === this.newMedication
          );
          this.InventoryID = inventory._id;
          this.addMedication();
        } else {
          this.updateMedication();
        }
      } catch (error) {
        console.error('Save validation error:', error);
        notyf.error("Please check all required fields and try again.");
      }
    },

    getUnits: function () {
      axios.get(`${url}/units`).then(async (res) => {
        this.units = res.data.units;
      });
    },

    async getProviders() {
      try {
        const response = await this.getClientProviders(this.clientID);
        this.providers = (response?.data || [])
          .filter(item => item.Provider && item.Provider.Name)
          .sort((a, b) => {
            return (a.Provider?.Name || '').localeCompare(b.Provider?.Name || '');
          });
      } catch (error) {
        console.error('Failed to fetch providers:', error);
        this.providers = [];
      }
    },

    close() {
      this.$router.go(-1);
      this.e1 = 1; //reset stepper to step 1 after close/cancel
      this.clearFields();
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    updateMedication() {
      // Convert arrays to strings for server compatibility
      const medClassString = Array.isArray(this.newMedClass) ? this.newMedClass.join(', ') : this.newMedClass;
      const assistanceString = Array.isArray(this.newAssistance) ? this.newAssistance.join(', ') : this.newAssistance;
      const scheduleOptionsString = Array.isArray(this.newScheduleOptions) ? this.newScheduleOptions.join(', ') : this.newScheduleOptions;

      let req_body = {
        ClientID: this.clientID,
        Medication: this.newMedication,
        DosageForm: this.newDosageForm,
        Diagnosis: this.newDiagnosis,
        AdministrationRoute: this.newAdministrationRoute,
        Vitals: this.newVitals,
        VitalsRequired: this.newRequiredVitals,
        Refills: this.newRefills,
        MedClass: medClassString,
        DrugCategory: this.newDrugCategory,
        WrittenOrder: this.newWrittenOrder ? this.newWrittenOrder : false,
        WrittenOrderType: this.writtenOrderType,
        Assistance: assistanceString,
        Instructions: this.newInstructions,
        Quantity: this.newQuantity,
        AdministerAmount: this.formattedDosage,
        Unit: this.newUnit,
        Dosage: this.newDosage,
        ScheduleOptions: scheduleOptionsString,
        StartDate: this.newStartDate,
        EndDate: this.newEndDate,
        IntervalDays: this.newIntervalDays,
        DaysOfWeek: this.newDaysOfWeek,
        DaysOfMonth: this.newDaysOfMonth,
        MARInstructions: this.newMARInstructions,
        AdditionalTiming: this.newAdditionalTiming,
        Strength: this.strength,
        // MedGroup: this.newMedGroup,
        PrescribedBy: this.providerId,
        RXNumber: this.newRXNumber,
        EnteredBy: this.newEnteredBy,
        NursingReview: this.newNursingReview,
        AdminTime: this.newAdminTime,
        MedInventory: this.InventoryID,
        PRN: this.prn,
        PRNDiagnosis: this.prnDiagnosis,
        UrlNotification: this.$router.history.current.path,
        IsIndefinite: this.isIndefinite,
        PrnInterval: this.prnInterval,
        ExpirationDate : this.newExpirationDate
      };

      this.showLoadingUpdateMedication();

      axios
        .put(`${url}/medications/${this.medicationID}`, req_body)
        .then((response) => {
          console.log(response);
          this.showSuccessUpdateMedication();
          // Only close after successful save
          this.close();
        })
        .catch((error) => {
          console.error("Request failed:", error);
          // Don't close on error, let user see the error
        });
    },

    getMedications() {
      this.isLoading = true;
      axios
        .get(`${url}/medications/all/${this.clientID}`)
        .then((res) => {
          this.medications = [];
          this.discontinuedMedications = [];
          this.tempData = res.data.medications;
          for (var i = 0; i < this.tempData.length; i++) {
            if (this.tempData[i].IsActive === true) {
              this.medications.push(this.tempData[i]);
            }

            if (this.tempData[i].IsActive === false) {
              this.discontinuedMedications.push(this.tempData[i]);
            }
          }
        })
        .finally(() => (this.isLoading = false));
    },

    getMedication() {
      axios
        .get(`${url}/medications/${this.medicationID}`)
        .then((response) => {
          this.medication = response.data.medication;
          this.viewMedication(this.medication);
        })
        .finally(() => (this.isLoading = false));
    },

    addSignature: function () {
      this.newEnteredBy = this.staff + " - " + moment().utc().toISOString();
    },

    formatSignature(enteredBy) {
      if (!enteredBy || enteredBy === "") {
        return "";
      }

      if (enteredBy.includes("Z")) {
        const [name, utcTime] = enteredBy.split(" - ");
        const cleanUtcTime = utcTime.replace("Z", ""); // Remove "Z" for parsing
        const localTime = moment.utc(cleanUtcTime, "YYYY-MM-DD HH:mm").local().format("YYYY-MM-DD HH:mm");
        return `${name} - ${localTime}`;
      }

      return enteredBy;
    },

    addMedication: function () {
      // Convert arrays to strings for server compatibility
      const medClassString = Array.isArray(this.newMedClass) ? this.newMedClass.join(', ') : this.newMedClass;
      const assistanceString = Array.isArray(this.newAssistance) ? this.newAssistance.join(', ') : this.newAssistance;
      const scheduleOptionsString = Array.isArray(this.newScheduleOptions) ? this.newScheduleOptions.join(', ') : this.newScheduleOptions;

      const req_body = {
        Medication: this.newMedication,
        DosageForm: this.newDosageForm,
        Diagnosis: this.newDiagnosis,
        AdministrationRoute: this.newAdministrationRoute,
        Vitals: this.newVitals,
        VitalsRequired: this.newRequiredVitals,
        Refills: this.newRefills,
        MedClass: medClassString,
        DrugCategory: this.newDrugCategory,
        WrittenOrder: this.newWrittenOrder,
        WrittenOrderType: this.writtenOrderType,
        Assistance: assistanceString,
        Instructions: this.newInstructions,
        Quantity: this.newQuantity,
        AdministerAmount: this.formattedDosage,
        Unit: this.newUnit,
        Dosage:
          this.newDosage !== "" && this.newDosage !== undefined
            ? this.newDosage.split(" ").join("")
            : this.newDosage,
        ScheduleOptions: scheduleOptionsString,
        StartDate: this.newStartDate,
        EndDate: this.newEndDate,
        IntervalDays: this.newIntervalDays,
        DaysOfWeek: this.newDaysOfWeek,
        DaysOfMonth: this.newDaysOfMonth,
        MARInstructions: this.newMARInstructions,
        AdditionalTiming: this.newAdditionalTiming,
        Strength: this.strength,
        PrescribedBy: this.providerId,
        RXNumber: this.newRXNumber,
        EnteredBy: this.newEnteredBy,
        NursingReview: this.newNursingReview,
        AdminTime: this.newAdminTime,
        ClientID: this.clientID,
        MedInventory: this.InventoryID === "" ? null : this.InventoryID,
        PRN: this.prn,
        PRNDiagnosis: this.prnDiagnosis,
        StaffID: this.userID,
        UrlNotification: this.$router.history.current.path,
        IsIndefinite: this.isIndefinite,
        PrnInterval: this.prnInterval,
        ExpirationDate : this.newExpirationDate
      };

      this.showLoadingAddMedication();

      axios
        .post(`${url}/medications`, req_body)
        .then((response) => {
          console.log(response);
          this.showSuccessAddMedication();
          // Only close after successful save
          this.close();
        })
        .catch((error) => {
          console.error("Request failed:", error);
          // Don't close on error, let user see the error
        });
    },

    interval: function () {
      this.intervalDays = true;
      this.specificDays = false;
      this.specificMonth = false;
    },

    daysOfTheWeek: function () {
      this.specificDays = true;
      this.intervalDays = false;
      this.specificMonth = false;
    },

    daysOfTheMonth: function () {
      this.specificMonth = true;
      this.intervalDays = false;
      this.specificDays = false;
    },

    checkVitals: function () {
      this.reqVitals = !this.reqVitals;
    },

    checkOptions: function (option) {
      //Add checkOptions params inorder to reuse this function when viewing meds
      this.times = true;
      if (option === "Daily or PRN") {
        this.dailyPRN = true;
        this.intervalDays = false;
        this.specificDays = false;
        this.specificMonth = false;
      } else if (option === "Every (Interval) Days") {
        this.dailyPRN = false;
        this.intervalDays = true;
        this.specificDays = false;
        this.specificMonth = false;
      } else if (option === "Specific Days of the Week") {
        this.dailyPRN = false;
        this.intervalDays = false;
        this.specificDays = true;
        this.specificMonth = false;
      } else {
        this.dailyPRN = false;
        this.intervalDays = false;
        this.specificDays = false;
        this.specificMonth = true;
      }
    },

    getInventories: function () {
      axios
        .get(`${url}/medicationInventory/item/${this.clientID}`)
        .then((res) => {
          this.inventories = res.data.client;
          this.inventories.sort((a, b) =>
            a.Medication.localeCompare(b.Medication)
          );
        });
    },

    qtyChange() {
      this.inventories.filter((item) => {
        if (item._id === this.newMedication._id) {
          this.newItem = item.Item;
          return (this.itemQty = item.Quantity);
        }
      });
      // this.qty = [...Array(parseInt(this.itemQty)).keys()].map((x) => x + 1);
      this.qty = this.itemQty;
    },

    clearFields() {
      this.newMedication = "";
      this.newDosageForm = "";
      this.newDiagnosis = "";
      this.newAdministrationRoute = "";
      this.newVitals = "";
      this.newRequiredVitals = [];
      this.newRefills = "";
      this.newMedClass = [];
      this.newDrugCategory = [];
      this.newWrittenOrder = false;
      this.writtenOrderType = null;
      this.newAssistance = [];
      this.newInstructions = "";
      this.newQuantity = "";
      this.newAdministerAmount = "";
      this.newUnit = "";
      this.newDosage = "";
      this.newScheduleOptions = [];
      this.newStartDate = new Date();
      this.newEndDate = new Date();
      this.newIntervalDays = "";
      this.newDaysOfWeek = [];
      this.newDaysOfMonth = [];
      // this.newStartDate = [];
      // this.newEndDate = [];
      this.newMARInstructions = "";
      this.newAdditionalTiming = "";
      // this.newMedGroup= "";
      this.newPrescribedBy = "";
      this.newRXNumber = "";
      this.newEnteredBy = "";
      this.newNursingReview = "";
      this.strength = 0;
      this.newAdminTime = [];
      this.prnDiagnosis = "";
      this.isIndefinite = true;
      this.times = false;
      this.reqVitals = false;
      this.dailyPRN = false;
      this.intervalDays = false;
      this.specificDays = false;
      this.specificMonth = false;

      // Reset validation state
      if (this.$refs.observer) {
        this.$refs.observer.reset();
      }
    },

    onSwitchStatus(e) {
      Swal.fire({
        title: 'Are you sure?',
        text: `You are about to change the status to ${e ? 'Active' : 'Inactive'}.`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, update it!',
        cancelButtonText: 'No, keep it',
      }).then((result) => {
        if (result.isConfirmed) {
          let req_body = {
            IsActive: e,
            IsIndefinite: e
          };

          axios
            .put(`${url}/medications/status/${this.medicationID}`, req_body)
            .then((response) => {
              this.getMedications();
              if (response.status === 400) {
                response.json().then(function (data) {
                  alert(data.msg);
                });
              }
              this.clearFields();
              this.msg = true;
              this.text = e
                ? "Medication Change status to Active"
                : "Medication Successfully Discontinued";
              Swal.fire('Updated!', this.text, 'success');
            })
            .finally(() => this.close());
        } else {
          this.isActive = this.medicationStatus
          Swal.fire('Cancelled', 'The status update was cancelled', 'error');
        }
      });
    },

    getDiagnoses(id) {
      axios.get(`${url}/diagnoses/client/${id}`).then((res) => {
        this.diagnoses = res.data.diagnoses;
      });
    },

    onSelectQuantity() {
      let dosage = 0;

      if (this.newDosage === "" || this.newDosage === undefined) return dosage;

      // dosage = this.medication.Dosage.split("mg")[0];

      //extract value from dosage
      //dosage = parseInt(this.medication.Dosage.replace(/^\D+|\D+$/g, ""))

      //extract dosage array /string[0]/number[1]/special character[2]
      dosage = this.newDosage.replace(/,/g, "").split(/(\d+\.?\d*)/);

      this.totalDosage = Math.round(dosage[1] * this.newQuantity * 100) / 100;

      if (this.newDosage === "" || Number.isNaN(this.totalDosage))
        return (this.newAdministerAmount = "");
      this.newAdministerAmount = this.totalDosage;
      this.formattedDosage =
        this.formattedTotalDosage(this.totalDosage) + dosage[2];
      this.instruction();
    },

    amountAdministered(item) {
      let dosage = 0;
      if (item === "" || item === undefined) return dosage;
      dosage = item.replace(/,/g, "").split(/(\d+\.?\d*)/);
      this.totalDosage = dosage[1] * this.newQuantity;
      return (this.formattedDosage =
        this.formattedTotalDosage(this.totalDosage) + dosage[2]);
    },

    updateMarInstructions() {
      this.instruction();
      this.onSelectQuantity();
    },

    updateMed() {
      this.medication = this.newMedication;
      this.newDosageForm = this.newMedication.DosageForm;
      this.InventoryID = this.newMedication._id;
      this.newDosage = this.newMedication.Dosage;
      this.newUnit = this.newMedication.DosageForm;
      this.instruction();
      this.newMedication = this.newMedication.Medication;
      this.isLoading = true;

      this.newPrescribedBy = this.providers.find(
        (provider) => provider.Provider._id === this.medication.PrescribedBy
      );

      this.newRXNumber = this.medication.RXNumber;
      this.newExpirationDate = DateTimeUtil.toLocalDate(this.medication.ExpirationDate);
    },

    instruction() {
      const units = this.newQuantity >= 2 ? `${this.newUnit}s` : this.newUnit;
      const schedule = this.newAdminTime[0] === "PRN"
        ? `${this.prnInterval} ${this.newAdminTime} for ${this.prnDiagnosis}. Follow up after ${this.prn}`
        : `at ${this.newAdminTime}`;

      let instruction = `Administer ${this.newQuantity} ${units} (${this.formattedDosage}) ${this.newAdministrationRoute} ${schedule}`;

      if (!this.isIndefinite) {
        const startDate = moment(this.newStartDate).startOf('day');
        const endDate = moment(this.newEndDate).startOf('day');
        const diffDays = endDate.diff(startDate, 'days');
        const dayText = diffDays === 1 ? 'day' : 'days';
        return this.newMARInstructions = `${instruction} for ${diffDays} ${dayText}`;
      }

      return this.newMARInstructions = instruction;
    },

    formattedTotalDosage(num) {
      return String(num).replace(/\d{1,3}(?=(\d{3})+(?!\d))/g, "$&,");
    },

    onChangeWittenOrder() {
      if (!this.newWrittenOrder) this.writtenOrderType = null;
    },

    async generateDownloadUrl() {
      return `${url}/medications/print?id=${this.medicationID}`;
    },

    async showPrintModal() {
      const downloadUrl = await this.generateDownloadUrl();
      PrintUtil.showPrintOption(downloadUrl, this.medicationID, this.token, 'MedicationForm');
    },

    onSelectProvider(id) {
      this.providerId = id;
    },

    showLoadingAddMedication() {
      notyf.open({
        type: "info",
        message: "Creating medication, please wait...",
      });
    },

    showLoadingUpdateMedication() {
      notyf.open({
        type: "info",
        message: "Updating medication, please wait...",
      });
    },

    showSuccessAddMedication() {
      notyf.success("The medication has been added successfully.");
    },

    showSuccessUpdateMedication() {
      notyf.success("The medication has been updated successfully.");
    },
  },
};
</script>
<style>
#chart {
  margin-left: auto;
  margin-right: auto;
}

@media only screen and (min-width: 1200px) {
  .v-text-field.mobileSearch {
    display: none;
  }
}

@media only screen and (min-width: 766px) {
  .v-text-field.mobileSearch {
    display: none;
  }

  .mobile {
    display: none;
  }
}

@media only screen and (max-width: 600px) {
  /* .v-text-field.mobileSearch {
        display: none;
      } */
  .desktop {
    display: none;
  }
}

@media only screen and (max-width: 480px) {
  /* .v-data-table {
      margin: 20px;
    }
    .v-toolbar-title {
      width: 100%;
    }
    .v-text-field.search {
      display: none;
    }
    .v-text-field.mobileSearch {
      display: block;
      padding-right: 30px;
      padding-left: 30px;
      padding-bottom: 0px;
      margin-bottom: 0px;
    } */
}
</style>
